import React from 'react';
import { Alert, Box, Card, CardContent, CardHeader, LinearProgress, Typography } from '@mui/material';

import AnnualSection from './AnnualSection';
import IncomeTaxSection from './IncomeTaxSection';
import MonthlySection from './MonthlySection';
import VatDetailsAccordion from './VatDetailsAccordion';

const buildSubheader = (mode, data, periodLabel) => {
    if (!data) {
        return 'Noch keine Daten berechnet';
    }
    const periodSuffix = periodLabel ? ` · ${periodLabel}` : '';
    if (mode === 'ust-month') {
        return `Monatliche USt-Auswertung${periodSuffix}`;
    }
    if (mode === 'ust-quarter') {
        return `Quartalsweise USt-Auswertung${periodSuffix}`;
    }
    if (mode === 'ust-annual') {
        return `Jährliche USt-Auswertung${periodSuffix}`;
    }
    if (mode === 'est-annual' || mode === 'est-month' || mode === 'est-quarter') {
        return `Einkommensteuer-Auswertung${periodSuffix}`;
    }
    return periodLabel || '';
};

export default function EvaluationResultCard({
    data,
    mode,
    loading,
    error,
    message,
    periodLabel,
    vatDetails,
    vatDetailsLoading,
    vatDetailsError,
    vatDetailsOpen,
    onVatDetailsToggle,
}) {
    return (
        <Card
            data-evaluation-result="true"
            sx={{
                borderRadius: 3,
                boxShadow: '0 6px 24px rgba(0,0,0,0.06)',
                '@media print': {
                    boxShadow: 'none',
                },
            }}
        >
            <CardHeader title="Ergebnis" subheader={buildSubheader(mode, data, periodLabel)} sx={{ pb: 0 }} />
            <CardContent>
                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}
                {message && (
                    <Alert severity="info" sx={{ mb: 2 }}>
                        {message}
                    </Alert>
                )}

                {loading && (
                    <Box sx={{ mb: 2 }}>
                        <LinearProgress />
                    </Box>
                )}

                {!data && !error && !message && !loading && (
                    <Typography color="text.secondary">
                        Wähle Jahr und Auswertungstyp. Für die USt-Voranmeldung kannst du zusätzlich einen Monat oder ein
                        Quartal angeben.
                    </Typography>
                )}

                {data && (mode === 'ust-month' || mode === 'ust-quarter') && <MonthlySection data={data} />}
                {data && mode === 'ust-annual' && <AnnualSection data={data} />}
                {data && (mode === 'est-annual' || mode === 'est-month' || mode === 'est-quarter') && <IncomeTaxSection data={data} />}
                {data && (mode === 'ust-month' || mode === 'ust-quarter' || mode === 'ust-annual' || mode === 'est-month' || mode === 'est-quarter' || mode === 'est-annual') && (
                    <VatDetailsAccordion
                        open={vatDetailsOpen}
                        loading={vatDetailsLoading}
                        error={vatDetailsError}
                        details={vatDetails}
                        onToggle={onVatDetailsToggle}
                    />
                )}
            </CardContent>
        </Card>
    );
}
